/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_TitleInputs */

const en_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Terminology Manager`)
};

const fr_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de terminologie KNP`)
};

const de_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Terminologiemanager`)
};

const it_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile della terminologia KNP`)
};

const ru_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер по терминологии KNP`)
};

const es_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de terminología de KNP`)
};

const zh_cn2_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP术语管理器`)
};

const ja_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP用語マネージャー`)
};

const hi_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी शब्दावली प्रबंधक`)
};

const pt_pt2_knp_manager_title = /** @type {(inputs: Knp_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Terminologia do KNP`)
};

/**
* | output |
* | --- |
* | "KNP Terminology Manager" |
*
* @param {Knp_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_title = /** @type {((inputs?: Knp_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_title(inputs)
	if (locale === "de") return de_knp_manager_title(inputs)
	if (locale === "it") return it_knp_manager_title(inputs)
	if (locale === "ru") return ru_knp_manager_title(inputs)
	if (locale === "es") return es_knp_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_title(inputs)
	if (locale === "ja") return ja_knp_manager_title(inputs)
	if (locale === "hi") return hi_knp_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_title(inputs)
	return en_knp_manager_title(inputs)
});